import React, {useEffect, useState} from "react";
import {ContentState, convertFromRaw, Editor, EditorState} from "draft-js";
import Typography from "@mui/material/Typography";

const createInitialState = (defaultValue) => {
	if (!defaultValue) {
		return EditorState.createEmpty();
	}

	try {
		return EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValue)));
	} catch (error) {
		return EditorState.createWithContent(ContentState.createFromText(defaultValue));
	}
};

const MUIRichTextEditorCompat = ({defaultValue, label, onChange}) => {
	const [editorState, setEditorState] = useState(() => createInitialState(defaultValue));

	useEffect(() => {
		setEditorState(createInitialState(defaultValue));
	}, [defaultValue]);

	const handleChange = (newState) => {
		setEditorState(newState);
		if (onChange) {
			onChange(newState);
		}
	};

	return (
		<div>
			{label && (
				<Typography color="textSecondary" variant="caption">
					{label}
				</Typography>
			)}
			<div style={{minHeight: 240, cursor: "text", paddingTop: 8}}>
				<Editor editorState={editorState} onChange={handleChange} placeholder={label}/>
			</div>
		</div>
	);
};

export default MUIRichTextEditorCompat;
